import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import Header from '../Header'

const orderListUrl = "https://zomatourl.herokuapp.com/orders"
const updateListUrl = "http://localhost:4000/updateOrder"

const OdrerList = () => {
  const location = useLocation()
  let querypayment = location.search
  const [userOrder, setUserOrder] = useState([])
  const [orderList, setOrderList] = useState({
    "status": querypayment.split('&')[0].split('=')[1],
    "date": querypayment.split('&')[2].split('=')[1].split('%')[0],
    "bank_name": querypayment.split('&')[3].split('=')[1]
  })

  let userToken = localStorage.getItem('authToken')

  useEffect(() => {
    let id = querypayment.split('&')[1].split('=')[1].split('_')[1];
    fetch(`${updateListUrl}/${id}`, {
      method: "PATCH",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body : JSON.stringify(orderList)
    })


    let email = localStorage.getItem('userdata').split(',')[1]
    fetch(`${orderListUrl}?email=${email}`, {
      method : "GET"
    })
    .then(res => res.json())
    .then(data => {
      setUserOrder(data)
      // console.log(data);
    })
    .catch(err => {
      console.log(err);
    })
  }, [userToken])


  return (
    <React.Fragment>
      <Header />
      {
        !userToken ? (
          <h1 style={{ marginTop: "120px", textAlign: "center" }}>Login First to Place Order</h1>
        ) : (
          <Container>
            <Row>
              <Col>
                <Table striped bordered hover className='mt-5'>
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Restaurant Name</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>Cost</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>BankName</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      userOrder.map((user, index) => {
                        return (
                          <tr key={index}>
                            <td>{user.orderId}</td>
                            <td>{user.rest_name}</td>
                            <td>{user.name}</td>
                            <td>{user.phone}</td>
                            <td>{user.email}</td>
                            <td>{user.cost}</td>
                            <td>{user.date}</td>
                            <td>{user.status}</td>
                            <td>{user.bank_name}</td>
                          </tr>
                        )
                      })
                    }

                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        )
      }

    </React.Fragment>
  )
}

export default OdrerList